function handleValidPolicy(rule, policy) {
  if (rule.check_statistics) {
    policy.eventPolicyStatistics = {
      eventPolicyStatisticsPeriod: rule.statisticsPeriod,
      eventPolicyStatisticsType: rule.statisticsType
    };
  }
  if (rule.thresholdItem == 'range') {
    policy.eventThreshold = {
      metricFunction: rule.metricFunction == 'NULL' ? '' : rule.metricFunction,
      rangeThreshold: {
        maxComparisonOperator: 'LE',
        maxValue: rule.thresholdMax,
        minComparisonOperator: 'GE',
        minValue: rule.thresholdMin
      },
      thresholdType: 'RANGE_VALUE'
    };
  } else {
    policy.eventThreshold = {
      metricFunction: rule.metricFunction == 'NULL' ? '' : rule.metricFunction,
      singleThreshold: {
        value: rule.thresholdMin,
        comparisonOperator: rule.thresholdItem
      },
      thresholdType: 'SINGLE_VALUE'
    };
  }
  return policy;
}
export { handleValidPolicy };
